import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  HostListener,
  Input
} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[ls-outside-click]'
})
export class OutsideClickDirective {
  @Input() public lsOutsideClickEnabled = true;
  @Output('ls-outside-click')
  public outsideClick: EventEmitter<MouseEvent> = new EventEmitter<
    MouseEvent
  >();

  constructor(private element: ElementRef) {}

  @HostListener('document:click', ['$event', '$event.target'])
  @HostListener('document:touchstart', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    if (!targetElement || !this.lsOutsideClickEnabled) {
      return;
    }

    const clickedInside: boolean = this.element.nativeElement.contains(
      targetElement
    );
    if (!clickedInside) {
      this.outsideClick.emit(event);
    }
  }
}
